import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getLinkToken = (payload) =>
  postRequest(replaceInUrl(apiEndpoints.plaid.getToken), payload);

export const checkPlaidMismatch = (payload) =>
  postRequest(replaceInUrl(apiEndpoints.plaid.checkMismatch), payload);
